<template>
  <div class="calico-document-section-page">
    <div class="calico-container">
      <CalicoDocumentSection
        title="Income Statement"
        description="An income statement, also known as the profit and loss (P&L) statement, summarizes a company's revenue, expenses, gains, and losses over a specific accounting period."
        :documents="documents" 
        @browse="browse"
        @edit="edit"
        @download="download"
        @delete="ondelete"
        @save="save" 
        @cancel="cancel"
      />
    </div>
  </div>
</template>

<script lang="js">
import CalicoDocumentSection from '@/components/pattern/documentSection/index.vue'

export default {
  name: 'CalicoDocumentSectionPage',
  components: {
    CalicoDocumentSection
  },
  data () {
    return {
        documents: [{
            name: "file-name.pdf",
            type: "pdf",
            size: 100,
            year: "2025",
            description: ""
        }]
    }
  },
  methods: {
    browse (file) {
        console.log("browse! ", file)
    },
    save () {
        console.log("save!")
    },
    edit () {
        console.log("edit!")
    },
    cancel () {
        console.log("cancel!")
    },
    download () {
        console.log("download!")
    },
    ondelete () {
        console.log("ondelete!")
    }
  }
}
</script>
<style lang="scss">
.calico-document-section-page {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1rem;
  .calico-container {
    @include stack-space($space-large);
    @include inset-space($space-large);
    width: 600px;
  }
  .calico-container-2 {
    @include stack-space($space-large);
    @include inset-space($space-large);
    background: $color-neutral-darkest;
    width: 600px;
  }
}
</style>
